import { useCallback } from 'react';
import { useLocation, NavigateOptions, To, useNavigate } from 'react-router-dom';
import { resolveTenantCode, toTenantPath } from 'src/lib/tenantRouting';

export default function useTenantNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      const tenantCode = resolveTenantCode(location.pathname);

      if (typeof to === 'string') {
        navigate(toTenantPath(to, tenantCode), options);
        return;
      }

      if (typeof to === 'object' && to !== null && 'pathname' in to && typeof to.pathname === 'string') {
        navigate({ ...to, pathname: toTenantPath(to.pathname, tenantCode) }, options);
        return;
      }

      navigate(to, options);
    },
    [navigate, location.pathname]
  );
}
